<div class="content-wrapper-inner">
  <div class="page-content">
    <div class="table-topbar">
      <div class="search-holder">
        <h3>Invoices</h3>
      </div>
      <div class="table-action-holder">
        <div class="create">
          <a
            *ngIf="isAdmin"
            (keyup.enter)="invoiceCreate()"
            tabindex="0"
            (click)="invoiceCreate()"
            class="btn btn-primary py-10 px-15 d-flex align-items-center"
            ><span class="icon-add"></span>Create invoice</a
          >
        </div>
      </div>
    </div>

    <div class="d-flex justify-content-between align-items-center gap-10 second-top-bar">
      <app-invoices-search class="flex-grow-1" (submitForm)="onSubmitSearchForm($event)"></app-invoices-search>
      <div class="d-flex justify-content-between align-items-center right-side">
        <div class="d-flex justify-content-between align-items-center">
          <div *ngIf="isAdmin" class="search-control me-20">
            <div
              (keyup.enter)="isAutoGeneratedFilterChecked = !isAutoGeneratedFilterChecked; $event.stopPropagation(); autoGenerateFilterChange()"
              tabindex="0"
              class="form-check form-switch d-flex justify-content-between align-items-center gap-10"
              (click)="isAutoGeneratedFilterChecked = !isAutoGeneratedFilterChecked; $event.stopPropagation(); autoGenerateFilterChange()">
              <input
                type="checkbox"
                class="form-check-input medium"
                [(ngModel)]="isAutoGeneratedFilterChecked"
                [ngModelOptions]="{ standalone: true }" />
              <label>Auto Generated</label>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="dataTables_wrapper form-inline dt-bootstrap pos-relative">
      <app-invoices-table (actions)="invoiceAction($event)" (changeBatch)="selectedRows = $event"></app-invoices-table>
      <!-- The table on batch select has an action menu shown … -->
      <div class="table-action-info-bar" *ngIf="selectedRows.length">
        <div class="info-left">
          <div class="text-icon-holder" tabindex="0" (keyup.enter)="batchClear()" (click)="batchClear()">
            <span class="icon">
              <span class="selected icon-done"></span>
            </span>
            <span class="text">{{ selectedRows.length }} Selected</span>
          </div>
        </div>
        <div class="info-right">
          <div tabindex="0" (keyup.enter)="batchCopySelectedRows()" class="text-icon-holder" (click)="batchCopySelectedRows()">
            <span class="icon">
              <span class="fas fa-copy"></span>
            </span>
            <span class="text">Copy</span>
          </div>
          <div tabindex="0" (keyup.enter)="batchGenerateZohoReport()" class="text-icon-holder" (click)="batchGenerateZohoReport()">
            <span class="icon">
              <span class="fas fa-file-invoice-dollar"></span>
            </span>
            <span class="text">Generate ZOHO invoice</span>
          </div>
          <div tabindex="0" (keyup.enter)="batchSendZohoInvoices()" class="text-icon-holder" (click)="batchSendZohoInvoices()">
            <span class="icon">
              <span class="fas fa-paper-plane"></span>
            </span>
            <span class="text">Send ZOHO invoices</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<ng-template #createModalTpl let-dialogRef="dialogRef">
  <div class="modal-header mb-10">
    <div class="modal-title">
      <h3 class="d-inline-block">Create invoice</h3>
      <button type="button" class="btn-close" (click)="dialogRef.close(false)">
        <span class="icon-close"></span>
      </button>
    </div>
  </div>
  <div class="modal-body">
    <app-invoices-form [showButtons]="false" (onAfterSave)="onAfterSave()"></app-invoices-form>
  </div>
  <div class="modal-footer pt-15">
    <div class="button-holder d-flex justify-content-between">
      <button *ngIf="createForm" class="btn btn-outline-dark" [disabled]="createForm.loading" (click)="dialogRef.close(false)">Cancel</button>
      <button
        *ngIf="createForm"
        type="submit"
        class="btn btn-primary ms-15"
        (click)="createForm.onSubmit()"
        [disabled]="createForm.loading || !createForm.form.valid">
        Confirm
      </button>
    </div>
  </div>
</ng-template>

<ng-template #paypalModalTpl let-dialogRef="dialogRef">
  <div class="modal-header mb-10">
    <div class="modal-title">
      <h3 class="d-inline-block">Invoice payment</h3>
      <button type="button" class="btn-close" (click)="dialogRef.close(false)">
        <span class="icon-close"></span>
      </button>
    </div>
  </div>
  <div class="modal-body">
    <div [hidden]="!paypalLoading" class="spinner">
      <div class="sk-spinner sk-spinner-pulse"></div>
    </div>
    <dl *ngIf="invoice" class="description-list invoice-details">
      <dt>ID</dt>
      <dd>{{ invoice.id }}</dd>
      <dt>Created on</dt>
      <dd>{{ invoice.createdAt | date: 'medium' }}</dd>
      <dt>Purchase Rate</dt>
      <dd>€{{ invoice.rateApplied ? invoice.rateApplied : '0' }}</dd>
      <ng-container *ngIf="invoice.analyticsFeeApplied">
        <dt>Analytics</dt>
        <dd>€{{ invoice.analyticsFeeApplied }}</dd>
      </ng-container>
    </dl>
    <hr />
    <dl *ngIf="invoice" class="description-list invoice-details">
      <dt class="text-muted">Discount</dt>
      <dd>€{{ invoice.discountApplied ? invoice.discountApplied.toFixed(2) : '0' }}</dd>
      <ng-container *ngIf="invoice.vatPercentage">
        <dt class="text-muted">VAT</dt>
        <dd>{{ invoice.vatPercentage }}%</dd>
      </ng-container>
      <ng-container *ngIf="invoice.amountPaid">
        <dt class="text-muted">Amount Paid</dt>
        <dd>€{{ invoice.amountPaid.toFixed(2) }}</dd>
      </ng-container>
      <dt class="text-muted">Total</dt>
      <dd>
        €{{ invoice.total ? invoice.total.toFixed(2) : '0' }}
        <span class="text-navy" *ngIf="invoice.vatValue as vatValue" [attr.title]="'VAT ' + invoice.vatPercentage + '%'">
          + {{ vatValue.toFixed(2) }}</span
        >
      </dd>
    </dl>
    <form *ngIf="invoiceSecret" #paypalForm action="https://www.paypal.com/cgi-bin/webscr" method="post">
      <input type="hidden" name="charset" value="utf-8" />
      <input type="hidden" name="currency_code" value="EUR" />
      <input type="hidden" name="business" value="financials@telqtele.com" />
      <input type="hidden" name="cmd" value="_xclick" />
      <input type="hidden" name="quantity" value="1" />
      <input type="hidden" name="item_name" [value]="'Invoice ' + invoice.id" />
      <input type="hidden" name="amount" [value]="invoice.paymentValue" />
      <input type="hidden" name="notify_url" [value]="paypalConfirmUrl" />
      <input type="hidden" name="return" [value]="paypalReturnUrl" />
      <input type="hidden" name="cancel_return" [value]="paypalCancelUrl" />
    </form>
  </div>
  <div class="modal-footer pt-15">
    <div class="button-holder d-flex justify-content-between">
      <button class="btn btn-outline-dark" (click)="dialogRef.close(false)">Cancel</button>
      <button type="button" class="btn btn-primary ms-15" [disabled]="!invoiceSecret" (click)="paypalForm.nativeElement.submit()">
        Confirm & continue
      </button>
    </div>
  </div>
</ng-template>

<ng-template #detailsModalTpl let-dialogRef="dialogRef">
  <div class="modal-header mb-10">
    <div class="modal-title">
      <h3 class="d-inline-block">Invoice details</h3>
      <button type="button" class="btn-close" (click)="dialogRef.close(false)">
        <span class="icon-close"></span>
      </button>
    </div>
  </div>
  <div class="modal-body">
    <div [hidden]="!detailsLoading" class="spinner">
      <div class="sk-spinner sk-spinner-pulse"></div>
    </div>
    <dl *ngIf="invoice" class="description-list invoice-details">
      <dt class="text-muted">ID</dt>
      <dd>{{ invoice.id }}</dd>
      <ng-container *ngIf="invoice.zohoInvoiceNumber">
        <dt class="text-muted">Invoice number</dt>
        <dd>{{ invoice.zohoInvoiceNumber }}</dd>
      </ng-container>
      <dt class="text-muted">Created on</dt>
      <dd>{{ invoice.createdAt | date: 'medium' }}</dd>
      <ng-container *ngIf="invoice.paymentType === 'POSTPAID' && invoice.totalAmountMt > 0">
        <dt class="text-muted">MT Testing</dt>
        <dd>€{{ invoice.totalAmountMt.toFixed(2) }} ({{ invoice.testCount }} tests at €{{ invoice.rateApplied | number: '1.2-3' }})</dd>
      </ng-container>
      <ng-container *ngIf="invoice.paymentType === 'PREPAID' && invoice.rateApplied > 0">
        <dt class="text-muted">MT Rate</dt>
        <dd>€{{ invoice.rateApplied | number: '1.2-3' }}</dd>
      </ng-container>
      <ng-container *ngIf="invoice.paymentType === 'POSTPAID' && invoice.totalAmountMo > 0">
        <dt class="text-muted">MO Testing</dt>
        <dd>€{{ invoice.totalAmountMo.toFixed(2) }} ({{ invoice.testCountMo }} tests at €{{ invoice.rateAppliedMo | number: '1.2-3' }})</dd>
      </ng-container>
      <ng-container *ngIf="invoice.paymentType === 'PREPAID' && invoice.rateAppliedMo > 0">
        <dt class="text-muted">MO Rate</dt>
        <dd>€{{ invoice.rateAppliedMo | number: '1.2-3' }}</dd>
      </ng-container>
      <ng-container *ngIf="invoice.paymentType === 'POSTPAID' && invoice.totalAmountCli > 0">
        <dt class="text-muted">CLI Testing</dt>
        <dd>€{{ invoice.totalAmountCli.toFixed(2) }} ({{ invoice.testCountCli }} tests at €{{ invoice.rateAppliedCli | number: '1.2-3' }})</dd>
      </ng-container>
      <ng-container *ngIf="invoice.paymentType === 'PREPAID' && invoice.rateAppliedCli > 0">
        <dt class="text-muted">CLI Rate</dt>
        <dd>€{{ invoice.rateAppliedCli | number: '1.2-3' }}</dd>
      </ng-container>
      <ng-container *ngIf="invoice.paymentType === 'POSTPAID' && invoice.totalAmountFlashCall > 0">
        <dt class="text-muted">Flash call Testing</dt>
        <dd>€{{ invoice.totalAmountFlashCall.toFixed(2) }} ({{ invoice.testCountFlashCall }} tests at €{{ invoice.rateAppliedFlashCall | number: '1.2-3' }})</dd>
      </ng-container>
      <ng-container *ngIf="invoice.paymentType === 'PREPAID' && invoice.rateAppliedFlashCall > 0">
        <dt class="text-muted">Flash call Rate</dt>
        <dd>€{{ invoice.rateAppliedFlashCall | number: '1.2-3' }}</dd>
      </ng-container>
      <ng-container *ngIf="invoice.commitmentFeeApplied">
        <dt class="text-muted">Commitment applied</dt>
        <dd>€{{ invoice.commitmentFeeApplied.toFixed(2) }}</dd>
      </ng-container>
      <ng-container *ngIf="invoice.analyticsFeeApplied">
        <dt class="text-muted">Analytics</dt>
        <dd>€{{ invoice.analyticsFeeApplied.toFixed(2) }}</dd>
      </ng-container>
      <ng-container *ngIf="invoice.paymentType === 'POSTPAID' && invoice.subtotal > 0">
        <dt class="text-muted">Subtotal</dt>
        <dd>€{{ invoice.subtotal.toFixed(2) }}</dd>
      </ng-container>
      <ng-container *ngIf="invoice.paymentType === 'PREPAID' && invoice.initialAmount > 0">
        <dt class="text-muted">Top up amount</dt>
        <dd>€{{ invoice.initialAmount.toFixed(2) }}</dd>
      </ng-container>
      <ng-container *ngIf="invoice.discountApplied > 0">
        <dt class="text-muted">Discount</dt>
        <dd>€{{ invoice.discountApplied ? invoice.discountApplied.toFixed(2) : '0' }}</dd>
      </ng-container>
      <dt class="text-muted">VAT</dt>
      <dd>{{ invoice.vatPercentage > 0 ? invoice.vatPercentage : 0 }}%</dd>
      <ng-container *ngIf="invoice.amountPaid">
        <dt class="text-muted">Amount Paid</dt>
        <dd>€{{ invoice.amountPaid.toFixed(2) }}</dd>
      </ng-container>
      <dt class="text-muted">Total</dt>
      <dd>
        €{{ invoice.total ? invoice.total.toFixed(2) : '0' }}
        <span *ngIf="invoice.vatValue > 0"> + €{{ invoice.vatValue.toFixed(2) }} (VAT)</span>
      </dd>
      <dt class="text-muted">Paid</dt>
      <dd>
        <i *ngIf="invoice.status !== 'PROCESSING' && invoice.paidAt" class="fas fa-check text-navy m-r"></i>
        <i *ngIf="invoice.status !== 'PROCESSING' && !invoice.paidAt" class="fas fa-times text-danger m-r"></i>
        <span class="label label-primary" *ngIf="invoice.status === 'PARTIALLY_PAID'">Partial payment</span>
        <span class="label label-default" *ngIf="invoice.status === 'PROCESSING'">Processing</span>
      </dd>
    </dl>
    <div *ngIf="partialPaymentShow" class="partial-payment">
      <form [formGroup]="partialPaymentForm" class="pos-relative form">
        <div class="form-group my-15">
          <label class="form-label required">Amount (EUR)</label>
          <input [(ngModel)]="partialPaymentModel.amount" formControlName="amount" type="text" class="form-control" />
          <input-errors [control]="partialPaymentForm.controls.amount" [service]="validationService"></input-errors>
        </div>
        <div class="button-holder d-flex justify-content-between">
          <button class="btn btn-outline-dark" (click)="partialPaymentShow = false">Cancel</button>
          <button [disabled]="!partialPaymentForm.valid" (click)="onSubmitPartialPayment()" class="btn btn-primary">Apply</button>
        </div>
      </form>
    </div>
  </div>
  <div class="modal-footer pt-15">
    <div class="button-holder d-flex justify-content-between">
      <button class="btn btn-outline-dark" (click)="dialogRef.close(false)">Cancel</button>
      <div class="btn-group">
        <button
          *ngIf="invoice && isAdmin && !invoice.void && invoice.status !== 'CONFIRMED' && invoice.status !== 'PARTIALLY_PAID'"
          (click)="onClickVoid()"
          class="btn btn-primary">
          Void
        </button>
        <button *ngIf="isPartialPaymentShow()" (click)="partialPaymentOpen()" [disabled]="partialPaymentShow" class="btn btn-primary">
          Partial payment
        </button>
        <button *ngIf="invoice && isAdmin && !invoice.paidAt && !invoice.void" (click)="onClickMarkAsPaid()" class="btn btn-primary">
          Mark as paid
        </button>
      </div>
    </div>
  </div>
</ng-template>
